import { MouseEvent, RefObject, useState } from 'react';
import {
  IMappedGroupSchedule,
  IMappedScheduleDateData,
  IMappedTeacherSchedule,
} from 'entities/types';

export const useCardClickModal = (
  containerRef: RefObject<HTMLDivElement>,
  modalWidth: number,
) => {
  const [selectedDaySchedule, setSelectedDaySchedule] = useState<
    IMappedGroupSchedule[] | IMappedTeacherSchedule[] | null
  >(null);
  const [selectedDateData, setSelectedDateData] =
    useState<IMappedScheduleDateData | null>(null);
  const [modalPosition, setModalPosition] = useState({ x: 0, y: 0 });

  const calculateSafePosition = (clickX: number, clickY: number) => {
    if (!containerRef.current) return { x: 0, y: 0 };

    const calendarRect = containerRef.current.getBoundingClientRect(); // Примерная ширина модального окна
    const modalHeight = 300; // Примерная высота

    let x = clickX - calendarRect.left;
    let y = clickY - calendarRect.top;

    // Корректировка по горизонтали
    if (x + modalWidth > calendarRect.width) {
      x = calendarRect.width - modalWidth - 10;
    }
    if (x < 10) x = 10;

    // Корректировка по вертикали
    if (y + modalHeight > calendarRect.height) {
      y = calendarRect.height - modalHeight - 10;
    }
    if (y < 10) y = 10;

    return { x, y };
  };

  const handleCardClick = (
    event: MouseEvent,
    schedule: IMappedGroupSchedule[] | IMappedTeacherSchedule[],
    dateData: IMappedScheduleDateData,
  ) => {
    if (containerRef.current) {
      const safePosition = calculateSafePosition(event.clientX, event.clientY);
      setModalPosition({
        x: safePosition.x,
        y: safePosition.y,
      });
    }

    if (!selectedDaySchedule) {
      setSelectedDaySchedule(schedule);
      setSelectedDateData(dateData);
    }
  };

  const closeModal = () => {
    setSelectedDaySchedule(null);
    setSelectedDateData(null);
  };

  return {
    selectedDaySchedule,
    selectedDateData,
    modalPosition,
    closeModal,
    handleCardClick,
  };
};
